<template>
  <!--右侧浮动-->
  <div class="right-tel-boxtab">
    <div class="leftbar" @click="openbar()" style="height: 695px;">
      <div class="zi">在线咨询</div>
    </div>
    <div class="cons" v-if="consIsShow">
      <div class="labs">
        <div class="tu"><img src="../../../../static/img/zixun_rexian.png" alt=""></div>
        <div class="rights">
          <p>客服热线</p><span>{{servicePhone}}</span><!--400-666-7151-->
        </div>
      </div>
      <div class="labs">
        <div class="tu"><img src="../../../../static/img/投诉建议图标.png" alt=""></div>
        <div class="rights" @click="openComplain">
          <p>投诉建议</p>
        </div>
      </div>
      <div class="labs">
        <div class="tu"><img src="../../../../static/img/zixun_shouce.png" alt=""></img></div>
        <div class="rights" @click="openShouce('1')">
          <p>操作手册</p>
        </div>
      </div>
      <div class="labs">
        <div class="tu"><img src="../../../../static/img/zixun_wenti.png" alt=""></img></div>
        <div class="rights" @click="openShouce('2')">
          <p>常见问题</p>
        </div>
      </div>
      <div class="labs" style="border-bottom: none;padding: 8px 0px 2px 25px;">
          <div class="tu"><img src="../../../../static/img/zixun_kefu.png" alt=""></img></div>
          <div class="rights"><p>在线客服</p></div>
      </div>
      <div class="labss">
        <el-image style="width: 120px; height: 120px" :src="weixinurl" @click="openkefu()">
        </el-image>
      </div>
      <div class="labs" style="border-bottom: none;padding: 8px 0px 2px 25px;">
        <div class="tu"><img src="../../../../static/img/zixun_xiazai.png" alt=""></img></div>
        <div class="rights">
          <p>下载发票</p>
        </div>
      </div>
      <div class="labss">
        <el-image style="width: 120px; height: 120px" :src="weixinurlb" @click="openfapiao()">
        </el-image>
      </div>
      <div class="huiding" v-show="gotop" @click="toTop">
        <div class="tu">
          <img src="../../../../static/img/zixun_shang.png" alt=""></img>
        </div>
        <div class="rights">
          <p>返回顶部</p>
        </div>
      </div>
    </div>
       <!-- 弹出在线客服 -->
      <el-dialog title="" :visible.sync="kefuVisible" top="200px" width="400px" :append-to-body="true" center>
        <div class="outs">
          <img width="200px" :src="weixinurl" alt="">
          <div class="wenzi">扫二维码联系客服</div>
          <div class="downredzi"></div>
          <el-button  class="outbtn" @click="kefuVisible = false" type="primary">确认</el-button>
        </div>   
      </el-dialog>
      <!-- 弹出下载发票 -->
      <el-dialog title="" :visible.sync="fapiaoVisible" top="200px" width="400px" :append-to-body="true" center>
        <div class="outs">
          <img width="200px" src="../../../../static/img/weixin.jpg" alt="">
          <div class="wenzi">扫二维码关注公众号</div>
          <div class="downredzi" @click="downfapiao()">下载发票</div>
          <el-button  class="outbtn" @click="fapiaoVisible = false" type="primary">确认</el-button>
        </div>   
      </el-dialog>
      <!--填写投诉建议--->
      <el-dialog title="投诉建议" :visible.sync="complaindialog" width="750px" :append-to-body="true">
        <el-form ref="complainForm" :model="complainForm" label-width="210px" >
          <div>
              <el-row>
                <el-col :span="24">
                  <el-form-item label-width="180px">
                    <span slot="label"><span style="color:red">*</span>承保类型：</span>
                    <el-select v-model="complainForm.bhtype" placeholder="请选择承保类型" style="width: 300px;" @change="queryByTypeInsur(complainForm.bhtype)">
                      <el-option v-for="item in bhtypelist" :key="item.value" :label="item.label" :value="item.label"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label-width="180px">
                    <span slot="label"><span style="color:red">*</span>承保机构：</span>
                    <el-select v-model="complainForm.insureName" placeholder="请选择承保机构"  style="width: 300px;">
                      <el-option v-for="item in insurelist" :key="item.uuid" :label="item.cmpName" :value="item.cmpName"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label-width="180px">
                    <span slot="label"><span style="color:red">*</span>投诉内容：</span>
                    <el-input type="textarea" :rows="4" v-model="complainForm.complainContent" placeholder="请输入投诉内容" maxlength="100" class="winput"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label-width="180px">
                    <span slot="label">投诉截图：</span>
                    <el-upload ref="uploadComplain" class="upload-demo" :action="uploadUrl" 
                      :before-upload="verifyfile"
                      :on-success="handleAvatarSuccess"
                      :limit="1"
                      v-if="complainForm.complainUrl == undefined || complainForm.complainUrl == '' || complainForm.complainUrl == null">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                    </el-upload>
                    <div v-if="complainForm.complainUrl != undefined && complainForm.complainUrl != '' && complainForm.complainUrl != null">
                      <el-button type="primary" @click="openComplainfile(complainForm.complainUrl)">查看</el-button>
                      <el-button type="primary" @click="handleRemove">删除</el-button>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <el-form-item label-width="180px">
                    <span slot="label"><span style="color:red">*</span>投诉人手机：</span>
                    <el-input v-model="complainForm.complainPhone" placeholder="投诉人手机" maxlength="13" class="winput"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label-width="180px">
                    <span slot="label"><span style="color:red">*</span>验证码：</span>
                    <el-input v-model="complainForm.verifyCode" placeholder="请输入手机验证码" maxlength="6" style="float:left" class="addinputwx"></el-input>
                    <el-button style="float:left" type="primary" @click="sendMessages" plain class="lbtn" v-show="Verification">获取手机验证码</el-button>
                    <el-button style="float:left" type="primary" class="lbtn" plain v-show="!Verification"><span>{{ timer }}</span>秒后重新获取</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
          </div>
        </el-form>
        <div style="padding-left: 250px;padding-top: 20px;padding-bottom: 30px">
          <span class="dialog-footer">
            <el-button style="width:100px" :loading="oloading" @click="complaindialog = false">取消</el-button>
            <el-button style="width:100px;margin-left: 10px;" type="primary" :loading="oloading" @click="subcomplain(complainForm)">提交</el-button>
          </span>
        </div>
      </el-dialog>
  </div>
  <!--右侧浮动结束-->
</template>
  
<script>
import utils from '@/utils/utils'
// import { sendMessage } from '@/api/SendSmsController'
import axios from 'axios'
export default {
  name: 'zixuntool',
  // components: {  },
  props: ['tradingCenter'],
  data() {
    return {
      barShow: true,
      consIsShow: true,
      weixinurl: '../../../../static/img/weixin.png',
      // weixinsrcList: ['../../../../static/img/weixin.png'],
      weixinurlb: '../../../../static/img/weixin.jpg',
      // weixinsrcListb: ['../../../../static/img/weixin.jpg'],
      flag_scroll: true,
      scroll: 0,
      // showHover1: false, showHover2: false, showHover3: false, showHover4: false,
      gotop: true,
      fapiaoVisible: false,
      kefuVisible: false,
      servicePhone:'400-666-7151',
      bhtypelist:[
        {value:'1',label:'保险保函'},
        {value:'2',label:'银行保函'},
        {value:'3',label:'担保保函'},
      ],
      Verification:true,
      timer: 60,
      oloading:false,
      complaindialog:false,
      complainForm:{},
      insurelist:[],
      incmpId:'',
      applyCode:''
      // ------------------------------------
    }
  },
  created(){
    // if(utils.verifyDate()){
      this.servicePhone = '400-666-7151'
      this.weixinurl = '../../../../static/img/weixin.png'
    // }else{
    //   this.servicePhone = '15555519973'
    //   this.weixinurl = '../../../../static/img/suhe.jpg'
    // }
    this.applyCode = this.$route.query.applyCode
    if(this.applyCode == undefined || this.applyCode == '' || this.applyCode == null){
      this.applyCode = this.$route.query.applycode
      if(this.applyCode == undefined || this.applyCode == '' || this.applyCode == null){
        this.applyCode = localStorage.getItem('comapplyCode')
      }else{
        localStorage.removeItem('comapplyCode')
        localStorage.setItem('comapplyCode',this.applyCode)
      }
    }else{
      localStorage.removeItem('comapplyCode')
      localStorage.setItem('comapplyCode',this.applyCode)
    }
    
  },
  computed: {
    uploadUrl: function() {
      return (
        process.env.VUE_APP_BASE_API + '/UpLoadImageController/upLoadImageIe'
      )
    }
  },
  mounted() {
    // 此处true需要加上，不加滚动事件可能绑定不成功
    window.addEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    openbar() {
      this.barShow = !this.barShow
      this.consIsShow = this.barShow
    },
    handleScroll() {
      let scrolltop =
        document.documentElement.scrollTop || document.body.scrollTop
      scrolltop > 30 ? (this.gotop = true) : (this.gotop = true)
    },
    toTop() {
      this.$emit('totop', '')
      // let top = document.documentElement.scrollTop || document.body.scrollTop;
      // // 实现滚动效果
      // const timeTop = setInterval(() => {
      //   document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
      //   if (top <= 0) {
      //     clearInterval(timeTop);
      //   }
      // }, 10);
    },
    openShouce(item) {
      // window.open('/static/image/shouce.pdf')
      //console.log('传的参数--->' + JSON.stringify(this.tradingCenter))
      if (item == '1') {
        // 操作手册
        if (this.tradingCenter == '3') {
          window.open(
            'https://img.gbbh.cn/regular/shuomingshu/呼伦贝尔市公共资源电子交易平台电子保函用户操作手册.pdf'
          )
        } else if (this.tradingCenter == '9') {
          window.open(
            'https://img.gbbh.cn/regular/shuomingshu/通辽市公共资源电子交易平台电子保函用户操作手册.pdf'
          )
        } else if (this.tradingCenter == '11') {
          window.open(
            'https://img.gbbh.cn/regular/shuomingshu/呼市公共资源电子交易平台电子保函用户操作手册.pdf'
          )
        } else if (this.tradingCenter == '13') {
          window.open(
            'https://img.gbbh.cn/regular/shuomingshu/塔城地区电子保函办理操作手册.pdf'
          )
        } else if (this.tradingCenter == '14') {
          window.open(
            'https://img.gbbh.cn/regular/shuomingshu/云南省公共资源电子交易平台电子保函办理用户操作手册.pdf'
          )
        } else if (this.tradingCenter == '15') {
          window.open(
            'https://img.gbbh.cn/regular/shuomingshu/巴彦淖尔市公共资源电子交易平台电子保函用户操作手册.pdf'
          )
        }
      } else if (item == '2') {
        if (this.tradingCenter != '14') {
          // 常见问题
          window.open(
            'https://img.gbbh.cn/regular/shuomingshu/常见问题汇总.pdf'
          ) // 新点系统常见问题
        }
        // 云南暂未整理好
      }
    },
    openfapiao () {
          this.fapiaoVisible = true
        },
    openkefu () {
      this.kefuVisible = true
    },    
    downfapiao() {
      window.open("../../../../static/img/weixin.jpg");
    },
    // 发送验证码
    sendMessages() {
      this.$axios({
        url:process.env.VUE_APP_BASE_API + '/SendSmsController/SendMessage',
        method:"post",
        data:{
          phoneNumbers: this.complainForm.complainPhone
        }
      }).then(res => {
          if (res.code != 20000) {
            this.$message(JSON.stringify(res.data.msg))
          } else {
            this.$message('发送成功')
            this.Verification = false //点击button改变v-show的状态
            let auth_timer = setInterval(() => {
              //定时器设置每秒递减
              this.timer-- //递减时间
              if (this.timer <= 0) {
                this.Verification = true //60s时间结束还原v-show状态并清除定时器
                clearInterval(auth_timer)
              }
            }, 1000)
          }
        })
        .catch(res => {})
    },
    /**打开投诉窗口 */
    openComplain(){
      this.complainForm = {}
      this.complaindialog = true
    },
    /**删除文件 */
    handleRemove(file,fileList){
      this.complainForm.complainUrl = ''
      this.$forceUpdate()
    },
    /**上传文件成功 */
    handleAvatarSuccess(response, file, fileList){
      this.complainForm.complainUrl = utils.getUrl() + response
      this.$refs.uploadComplain.clearFiles()
      this.$forceUpdate()
    },
    /**查询承保机构 */
    queryByTypeInsur(bhtype){
      this.insurelist = []
      this.$axios({
        url: process.env.VUE_APP_BASE_API +  '/complain/selectByTypeInsure',
        method:'post',
        data:{
          bhType: bhtype,
          applyCode: this.applyCode
        }
      }).then(res=>{
        if(res.code == 20000){
          this.insurelist = res.data
        }
      })
    },
    /**验证文件格式 */
    verifyfile(file){
            let filetype = ''
            switch(file.type){
                case 'application/pdf':
                    filetype = 'pdf'
                    break
                case 'image/jpeg':
                    filetype = 'jpeg'
                    break
                case 'image/png':
                    filetype = 'png'
                    break
                case 'application/msword':
                    filetype = 'doc'
                    break
                case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                    filetype = 'docx'
                    break
                default:
                  filetype = '类型错误'
            }
            /**验证 */
            if(filetype != 'pdf' && filetype != 'jpeg' && filetype != 'png' && filetype != 'doc' && filetype != 'docx'){
                this.$notify({
                        title: '提示',
                        message: '请上传图片文件或者pdf和word文件',
                        type: 'error'
                    })
                return false
            }
            /**验证文件大小 */
            const isLt5M = file.size / 1024 / 1024 < 5; // 小于2MB
            if (!isLt5M) {
                this.$notify({
                    title: '提示',
                    message: '上传的文件大小不能超过 5MB!',
                    type: 'error'
                })
                return false
            }
    },
    /**查看文件 */
    openComplainfile(item){
      if(item != undefined && item != '' && item != null){
        window.open(item)
      }
    },
    /**提交投诉信息 */
    subcomplain(item){
      if(item.bhtype == undefined || item.bhtype == '' || item.bhtype == null){
        this.$notify({
          title:'提示',
          message:'请选择承保类型',
          type:'error'
        })
        return false
      }
      if(item.insureName == undefined || item.insureName == '' || item.insureName == null){
        this.$notify({
          title:'提示',
          message:'请选择承保机构',
          type:'error'
        })
        return false
      }
      if(item.complainContent == undefined || item.complainContent == '' || item.complainContent == null){
        this.$notify({
          title:'提示',
          message:'请输入投诉内容',
          type:'error'
        })
        return false
      }
      if(item.complainPhone == undefined || item.complainPhone == '' || item.complainPhone == null){
        this.$notify({
          title:'提示',
          message:'请输入投诉人手机号',
          type:'error'
        })
        return false
      }else{
        const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
        if (!reg.test(item.complainPhone)) {
          this.$notify({
            title:'提示',
            message:'请填写正确的手机号格式',
            type:'error'
          })
          return false
        }
        if(item.verifyCode == undefined || item.verifyCode == '' || item.verifyCode == null){
          this.$notify({
            title:'提示',
            message:'请输入手机验证码',
            type:'error'
          })
          return false
        }

        //验证验证码
        this.$axios({
          url:process.env.VUE_APP_BASE_API + '/ThirdPartProjectController/verifphoneCode',
          method:'post',
          params:{
            phone: item.complainPhone,
            code: item.verifyCode
          }
        }).then(res=>{
          if(res.code == 20000){
              this.subcomplainData(item)
          }else{
            this.$notify({
              title:'提示',
              message:res.msg,
              type:'error'
            })
          }
        }).catch(e=>{
          this.$notify({
            title:'提示',
            message:'提交失败',
            type:'error'
          })
        })
      }
    },
    /**提交投诉信息 */
    subcomplainData(item){
      this.oloading = true
      item.applyCode = this.applyCode
      this.$axios({
        url: process.env.VUE_APP_BASE_API + '/complain/add',
        method:'post',
        data:item
      }).then(res=>{
        this.oloading = false
        if(res.code == 20000){
          this.$notify({
            title:'提示',
            message:'提交成功',
            type:'success'
          })
          this.complaindialog = false
        }else{
          this.$notify({
            title:'提示',
            message:res.msg,
            type:'error'
          })
          return false
        }
      }).catch(e=>{
        this.$notify({
          title:'提示',
          message:'提交失败',
          type:'error'
        })
      })
    }
  },
}
</script>
  <style scoped>
  .outs{text-align: center;margin: 20px auto;}
  .outs img{border: 2px solid #116dc1;padding: 0px;}
  .outs .wenzi{text-align: center;padding: 20px 0 10px 0;font-size: 18px;}
  .outs .downredzi{text-align: center;font-size: 18px;color: #ff0a0c;font-weight: bold;padding: 0 0 30px 0;cursor: pointer;}
  .outs .outbtn{width: 200px;border-radius: 20px;font-weight: bold;color: #fff;}
</style>
  


// WEBPACK FOOTER //
// src/components/page/filetools/zixuntool.vue